import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { paths } from '../../../../common/constants/pathVariables.js';
import { OfferType } from '../../../../common/enums.js';
import { fetchProductOffersForOfferTypeWithAddress } from '../../../../common/fetch.js';
import { EmptyOrError, getNotFoundError } from '../../../../components/EmptyOrError/index.js';
import { Loading } from '../../../../components/Loading/index.js';
import { NettiLiteOffersCoCo } from '../../../../components/NettiLiteOffers/NettiLiteOffersCoCo.js';

import type { ProductOfferingsResponse } from '../../../../generated/api/productOfferingsResponse.js';

export const FixedBroadbandOffersPathCoCo = () => {
  const navigate = useNavigate();
  const { state, search } = useLocation();
  const [offerAvailabilityLoading, setOfferAvailabilityLoading] = useState<boolean>(true);
  const [fixLineProductOfferings, setFixLineProductOfferings] = useState<ProductOfferingsResponse[]>([]);

  const selectedAddressId = state?.searchAddress;

  useEffect(() => {
    setOfferAvailabilityLoading(true);
    if (selectedAddressId) {
      fetchProductOffersForOfferTypeWithAddress(OfferType.FIXED_BB, selectedAddressId)
        .then(resp => {
          setFixLineProductOfferings(Array.isArray(resp) ? resp : []);
          setOfferAvailabilityLoading(false);
        })
        .catch(() => setOfferAvailabilityLoading(false));
    } else {
      navigate(paths.ANONYMOUS_FIXED_BROADBAND_ORDER + search);
    }
  }, [navigate, search, selectedAddressId]);

  if (offerAvailabilityLoading) {
    return <Loading />;
  }

  if (!state?.previousUrl) {
    return (
      <EmptyOrError {...getNotFoundError()} onButtonClick={() => navigate(paths.ANONYMOUS_FIXED_BROADBAND_ORDER)} />
    );
  }

  return (
    <NettiLiteOffersCoCo
      availabilityAddress={state?.searchAddressText ?? state?.searchAddress}
      availabilityAddressId={selectedAddressId}
      postalCode={state?.postalCode}
      city={state?.city}
      fixLineProductOfferings={fixLineProductOfferings}
    />
  );
};
